import axios from "axios";
import { jwtDecode } from "jwt-decode";

const isTokenExpired = (token) => {
  const decoded = jwtDecode(token);
  const now = Date.now() / 1000;
  return decoded.exp < now;
};

//const API_BASE_URL = "http://a6de752220516488aae8f307f745715a-1051393800.ap-south-1.elb.amazonaws.com/stock_details";
const API_BASE_URL = "https://api.starmarketapi.online/reviews1";
const apiClient = axios.create({
  //baseURL: "http://a6de752220516488aae8f307f745715a-1051393800.ap-south-1.elb.amazonaws.com/stock_details", // Add your base URL here
  baseURL: "https://api.starmarketapi.online/reviews1",
  timeout: 5000, // Set a timeout if needed
  headers: {
    "Content-Type": "application/json",
  },
});
const FIREBASE_API_KEY = "AIzaSyClUDO4rvtOJsEIPiddWHvnDeszHXZf96A";
const FIREBASE_REFRESH_URL = `https://securetoken.googleapis.com/v1/token?key=${FIREBASE_API_KEY}`;
// Tokens state
let accessToken = null;
let refreshToken = null;

// Function to set tokens (call this after login)
export const setTokens = (newAccessToken, newRefreshToken) => {
  accessToken = newAccessToken;
  refreshToken = newRefreshToken;
};

apiClient.interceptors.request.use(async (config) => {
  let token = localStorage.getItem("accessToken");

  if (token && isTokenExpired(token)) {
    const refreshToken = localStorage.getItem("refreshToken");

    if (refreshToken) {
      const payload = new URLSearchParams();
      payload.append("grant_type", "refresh_token");
      payload.append("refresh_token", refreshToken);

      const refreshResponse = await axios.post(FIREBASE_REFRESH_URL, payload, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });

      token = refreshResponse.data.id_token;
      localStorage.setItem("accessToken", token);
      localStorage.setItem("refreshToken", refreshResponse.data.refresh_token);
    }
  }

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    refreshToken = localStorage.getItem("refreshToken");

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      try {
        // Call Firebase's refresh token endpoint
        const refreshResponse = await axios.post(FIREBASE_REFRESH_URL, {
          grant_type: "refresh_token",
          refresh_token: refreshToken,
        });

        accessToken = refreshResponse.data.id_token;
        refreshToken = refreshResponse.data.refresh_token;

        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);

        // Update headers
        apiClient.defaults.headers["Authorization"] = `Bearer ${accessToken}`;
        originalRequest.headers["Authorization"] = `Bearer ${accessToken}`;
        console.log("Firebase token refreshed");

        return apiClient(originalRequest);
      } catch (refreshError) {
        console.error("Firebase token refresh failed:", refreshError);
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
